import createModule from "../createModule"
import view from "./view"
import { Creators } from "./model"
import { Creators as PortfolioRootCreators } from "modules/portfolio-root/model"
import { getViewType, getPeriod, getPortfolioId, getSelectedModelId, getIsActive, getCurrency } from "modules/portfolio-root/selectors/portfolios"
import { getEarliestDate, getLatestDate } from "modules/portfolio-root/selectors/dates"
import { getFetchStartDate, getEndDate, getSelectedDate, getAiSummaryStartDate } from "selectors/dates"
import { Creators as notificationsCreators } from "modules/notifications/model"
import { getOptions, getSelectedOption, getFilteredData, getCategoryItemsSubset } from "./selectors/data"
import { getBaseSignature, getBasePositionSet } from "selectors/base"
import { getDisplayType, getDisplayTypeName } from "./selectors/items"
import { getFileName } from "./selectors/file"
import { getSegment } from "modules/analyze-header/selectors/segment"
import { getFiltersVisible } from "modules/analyze-header/selectors"
import { getFirstForecastDate, getCurrentForecast, getAdjustedEndDate, getAdjustedSelectedDate, getIsAdjusted, getPassthroughResourcesStatus } from "./selectors/forecast"
import withUrlParams from "hocs/withUrlParams"

export default withUrlParams(createModule({
  view,
  externalProps: (state, props) => ({
    portfolioShortId: state.global.selected.portfolio,
    portfolioId: getPortfolioId(state, props),
    account: state.global.selected.account,
    modelId: getSelectedModelId(state, props),
    startDate: getFetchStartDate(state, props),
    aiSummaryStartDate: getAiSummaryStartDate(state, props),
    endDate: getEndDate(state, props),
    selectedDate: getSelectedDate(state, props),
    viewType: getViewType(state, props),
    base: getBasePositionSet(state, props),
    baseSignature: getBaseSignature(state, props),
    segment: getSegment(state, props),
    isActive: getIsActive(state, props),
  }),
  required: ["account", "portfolioShortId", "modelId"],
  data: [{
    resource: "dailyForecast",
    as: null,
    passthrough: true,
    url: ({ portfolioId, modelId, startDate, endDate, params: { forecastId }, segment }) => {
      return {
        id: `${modelId}${portfolioId}${startDate}${endDate}${forecastId}${JSON.stringify(segment)}`,
        query: `query ($modelId: String!, $positionSet: PositionSetInput!, $from: Date!, $to: Date!, $forecastId: ShortId!) {
          model (id: $modelId) {
            simulation(positionSet: $positionSet, from: $from, to: $to, interval: AUTO) {
              dailyForecast (forecastId: $forecastId) {
                date
                expectedReturn
              }
            }
          }
        }`,
        variables: {
          modelId,
          positionSet: {
            type: "PORTFOLIO",
            id: portfolioId,
            segment,
          },
          from: startDate,
          to: endDate,
          forecastId,
        },
      }
    },
  }],
  mapStateToProps: (state, props) => ({
    earliestDate: getEarliestDate(state, props),
    latestDate: getLatestDate(state, props),
    firstDate: getFirstForecastDate(state, props),
    data: getFilteredData(state, props),
    items: getCategoryItemsSubset(state, props),
    options: getOptions(state, props),
    period: getPeriod(state, props),
    fileName: getFileName(state, props),
    ...state.modules.analyzeForecast,
    displayType: getDisplayType(state, props),
    displayTypeName: getDisplayTypeName(state, props),
    selectedOption: getSelectedOption(state, props),
    filtersVisible: getFiltersVisible(state, props),
    forecast: getCurrentForecast(state, props),
    endDate: getAdjustedEndDate(state, props),
    selectedDate: getAdjustedSelectedDate(state, props),
    adjusted: getIsAdjusted(state, props),
    currency: getCurrency(state, props),
    passthroughResourcesStatus: getPassthroughResourcesStatus(state, props),
  }),
  actions: {
    ...Creators,
    setDate: PortfolioRootCreators.setDate,
    resetDate: PortfolioRootCreators.resetDate,
    setPeriod: PortfolioRootCreators.setPeriod,
    addNotification: notificationsCreators.add,
  },
}))
